<template>
<div class="form-group" :class="{feedback : validationMessage}">
  <label v-if="!checkBoxType">{{label}}:</label>
  <b-input
    v-if="!checkBoxType"
    :type="type"
    :name="field"
    :ref="field"
    v-model="value"
    required
    :placeholder="label"/>
  <checkBox
    v-if="checkBoxType"
    :label="label"
    ref="chbx"
    :checked="value"></checkBox>
  <transition name="slide-down">
    <p v-show="validationMessage" class="alert alert-danger feedback-message">
          {{getMsg(field)}}
    </p>
  </transition>
</div>
</template>

<script>

import checkBox from '@/components/Modules/Misc/checkBox';

export default {
  name: 'FieldForm',
  components: {
    checkBox
  },
  props: ['label', 'field', 'msg', 'type', 'val'],
  watch: {
    val: function () {
      if (this.type === 'checkbox') { this.$refs.chbx.checked = this.val; } else this.value = this.val;
    }
  },
  computed: {
    validationMessage () {
      return this.getMsg(this.field) !== '';
    },
    textType () {
      return this.type === 'text';
    },
    checkBoxType () {
      return this.type === 'checkbox';
    },
    compValue () {
      return this.type === 'checkbox' ? this.$refs.chbx.checked : this.value;
    }
  },
  methods: {
    reset: function () {
      this.value = '';
      if (this.type === 'checkbox') {
        this.$refs.chbx.reset();
      }
    },
    getMsg: function (col) {
      try {
        let out = this.msg[col].join(' ');
        return out;
      } catch (err) {
        return '';
      }
    }

  },
  data () {
    return {
      value: '',
      showValidation: true
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Users/FormField.vue